export const loadLocalStorageState = () => {
    try {
        if (!localStorage.getItem("state")) {
            return undefined;
        }

        return JSON.parse(localStorage.getItem("state")) || {};
    } catch (error) {
        console.log(error);
        return {};
    }
};

export const loadSessionStorageState = () => {
    try {
        if (!sessionStorage.getItem("state")) {
            return undefined;
        }

        return JSON.parse(sessionStorage.getItem("state")) || {};
    } catch (error) {
        console.log(error);
        return {};
    }
};

export const saveLocalStorageState = state => {
    try {
        const stateJson = JSON.stringify(state);
        localStorage.setItem("state", stateJson);
    } catch (error) {
        console.log(error);
    }
};

export const saveSessionStorageState = state => {
    try {
        const stateJson = JSON.stringify(state);
        sessionStorage.setItem("state", stateJson);
    } catch (error) {
        console.log(error);
    }
};
